import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SearchIcon from '@mui/icons-material/Search';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import React, { useState } from "react"
import { useNavigate } from "react-router-dom";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { useGetMyProfileQuery } from '../../../../../services/ProfileService';
import { hasInsuranceVerifyAccess, hasVobManagerAccess } from '../../../../profile/utils/profileUtils';
import { FC_DASHBOARD_PATH, FC_ASSIGNMENT_MANAGEMENT_PATH, FC_SEARCH_PATH, FC_PREQUOTES_PATH } from '../../../../financialClearance/routes';

function FinancialClearanceMenu(){
    const navigate = useNavigate();
    const [finClearOpen, setFinClearOpen] = useState(false);
    const { data: profile } = useGetMyProfileQuery();

    const navigateToDashboard = () => {
        navigate(FC_DASHBOARD_PATH);
    };

    const navigateToAssignmentManagement = () => {
        navigate(FC_ASSIGNMENT_MANAGEMENT_PATH);
    };

    const navigateToSearch = () => {
        navigate(FC_SEARCH_PATH);
    };

    const navigateToPreQuotes = () => {
        navigate(FC_PREQUOTES_PATH);
    };
    
    return <React.Fragment>
        <AuthenticatedTemplate>
            {hasInsuranceVerifyAccess(profile) && (
                <List component='nav' sx={{border:'black solid 1px'}}>
                    <ListItemButton data-testid='fc-nav-group' onClick={() => setFinClearOpen(!finClearOpen)}>
                        <ListItemText primary='Financial Clearance' />
                        {finClearOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={finClearOpen} timeout="auto" unmountOnExit>
                        <ListItemButton sx={{marginTop:'0px'}} onClick={navigateToDashboard}>
                            <ListItemIcon><DashboardIcon sx={{color:'white'}}/></ListItemIcon>
                            <ListItemText primary='Dashboard' />
                        </ListItemButton>
                        <ListItemButton data-testid='fc-nav-search' sx={{marginTop:'0px'}} onClick={navigateToSearch}>
                            <ListItemIcon><SearchIcon sx={{color:'white'}}/></ListItemIcon>
                            <ListItemText primary='Case Search' />
                        </ListItemButton>
                        <ListItemButton data-testid='fc-nav-prequotes' sx={{marginTop:'0px'}} onClick={navigateToPreQuotes}>
                            <ListItemIcon><RequestQuoteIcon sx={{color:'white'}}/></ListItemIcon>
                            <ListItemText primary='Pre-Quotes' />
                        </ListItemButton>
                        {hasVobManagerAccess(profile) && (
                            <ListItemButton sx={{marginTop:'0px'}} onClick={navigateToAssignmentManagement}>
                                <ListItemIcon><AssignmentIndIcon sx={{color:'white'}}/></ListItemIcon>
                                <ListItemText primary='Assignment Management' />
                            </ListItemButton>
                        )}
                    </Collapse>
                </List>
            )}
        </AuthenticatedTemplate>
    </React.Fragment>
}

export {FinancialClearanceMenu}